export default __webpack_public_path__ + "static/media/defaultAvatar.1867a4a4.svg";